// import React, { useEffect, useState } from "react";
// import { PieChart } from "react-minimal-pie-chart";
// import { PlusIcon } from "../assets/icons";
// import PageHeader from "../components/PageHeader";
// import { routes } from "../helpers/constants";
// import { useDispatch, useSelector } from "react-redux";
// import { useSidebar } from "../content/SidebarContent";
// import {
//   reqToGetDashbaordDeatils,
//   reqToGetRecentTenants,
// } from "../redux/slices.js/admins/adminsSlice";
// import userProfile from "../assets/images/user.png";
// import { IMAGE_URL } from "../config";
// import { useNavigate } from "react-router-dom";

// const DashboardPage = () => {
//   const { setIsSidebarOpen } = useSidebar();
//   const dashboard = useSelector((state) => state.admins.dashboard);
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const recentTenants = useSelector((state) => state.admins.recentTenants);
//   const loader = useSelector((state) => state.tenants.recentTenantsLoader);

//   const [timeFilter, setTimeFilter] = useState("month"); // all, week, month, year
//   const [revenueFilter, setRevenueFilter] = useState("month"); // week, month, year

//   // 🔹 Get revenue value based on filter
//   const getRevenueValue = () => {
//     switch (revenueFilter) {
//       case "week":
//         return dashboard?.getTodayRevenue || 0;
//       case "month":
//         return dashboard?.getThisMonthRevenue || 0;
//       case "year":
//         return dashboard?.getThisYearRevenue || 0;
//       default:
//         return 0;
//     }
//   };

//   const data = [
//     {
//       value: dashboard?.private_tenant_count,
//       color: "#9C9AA5",
//       text: "Private",
//     },
//     { value: dashboard?.public_tenant_count, color: "#76AB90", text: "Public" },
//     {
//       value: dashboard?.startup_tenant_count,
//       color: "#1B3C52",
//       text: "Startup",
//     },
//   ];

//   const mapData = [
//     {
//       value: dashboard?.tenantCount_1_10,
//       color: "#9C9AA5",
//       text: "1-10 Employees",
//     },
//     {
//       value: dashboard?.tenantCount_11_50,
//       color: "#76AB90",
//       text: "11-50 Employees",
//     },
//     {
//       value: dashboard?.tenantCount_51_200,
//       color: "#1B3C52",
//       text: "50-200 Employees",
//     },
//     {
//       value: dashboard?.tenantCount_200plus,
//       color: "#648aa3",
//       text: "200+ Employees",
//     },
//   ];

//   const total = data.reduce((sum, d) => sum + d.value, 0);
//   const mapTotal = mapData.reduce((sum, d) => sum + Number(d.value), 0);

//   // 🔹 Load dashboard once
//   useEffect(() => {
//     dispatch(
//       reqToGetDashbaordDeatils({
//         onSuccess: () => {},
//         onFailure: () => {},
//       })
//     );
//   }, [dispatch]);

//   // 🔹 Load tenants when filter changes
//   useEffect(() => {
//     dispatch(
//       reqToGetRecentTenants({
//         data: timeFilter !== "all" ? { date: timeFilter } : {},
//         onSuccess: () => {},
//         onFailure: () => {},
//       })
//     );
//   }, [dispatch, timeFilter]);

//   return (
//     <section className="dashboard-page main-layout-page main-layout h-[calc(100vh-50px)]">
//       <div className="!p-0">
//         <div className="main-layout-wrapper bg-white h-screen flex flex-col sticky z-1 top-0">
//           <PageHeader
//             title="Good Morning, Totok!"
//             description="Tuesday 15th July - What do you like to do?"
//             onOpenSidebar={() => setIsSidebarOpen(true)}
//             hasSearch={true}
//           />

//           <div className="flex-1 right-sidebar h-full relative ">
//             <div className="right-sidebar-contend py-6 px-3 md:ps-[24px] md:p-6 pb-[50px] md:ps-0 h-full right-import-csv">
//               <div className="dashboard-all-btns flex md:hidden items-center gap-5 flex-wrap justify-between mb-5">
//                 <div className="flex-none all-btns"></div>
//                 <div className="dashboard-btns flex items-center justify-start sm:justify-end flex-wrap gap-3 sm:gap-4">
//                   <button
//                     className="text-white login-btn w-fit"
//                     onClick={() => navigate(routes.addTenants)}
//                   >
//                     {PlusIcon} Add Tenant
//                   </button>
//                 </div>
//               </div>

//               <div className="grid md:grid-cols-2 gap-4 md:gap-6 items-start">
//                 <div className="space-y-5 md:mt-[67px] mt-0">
//                   {/* 🔹 Recent Tenants */}
//                   <div className="bg-white box-shadow p-5 space-y-4 rounded-md">
//                     <div className="flex justify-between items-center">
//                       <h2 className="text-h4 text-blue mb-0">
//                         Recent Tenants {recentTenants?.length}
//                       </h2>
//                       <div className="flex items-center gap-2">
//                         <span className="text-body-span text-blue">
//                           Filter:
//                         </span>
//                         <select
//                           className="border border-gray-300 rounded p-1 text-body-span"
//                           value={timeFilter}
//                           onChange={(e) => setTimeFilter(e.target.value)}
//                         >
//                           <option value="year">All Time</option>
//                           <option value="week">Last Week</option>
//                           <option value="month">Last Month</option>
//                           <option value="year">Last Year</option>
//                         </select>
//                       </div>
//                     </div>
//                     <div className="dashboard-data-table">
//                       <table className="min-w-full">
//                         <thead className="bg-white-vlight p-2 h-[45px]">
//                           <tr>
//                             <th className="p-2 text-sub_span text-blue !font-extrabold text-left">
//                               Company Name
//                             </th>
//                             <th className="p-2 text-sub_span text-blue !font-extrabold text-left">
//                               Email
//                             </th>
//                             <th className="p-2 text-sub_span text-blue !font-extrabold text-left">
//                               website
//                             </th>
//                             <th className="p-2 text-sub_span text-blue !font-extrabold text-left">
//                               Created
//                             </th>
//                           </tr>
//                         </thead>

//                         <tbody>
//                           {loader ? (
//                             <tr>
//                               <td
//                                 colSpan="4"
//                                 className="text-center py-6 text-gray-500 font-medium"
//                               >
//                                 Loading...
//                               </td>
//                             </tr>
//                           ) : recentTenants?.length === 0 ? (
//                             <tr>
//                               <td
//                                 colSpan="4"
//                                 className="text-center py-6 text-gray-500 font-medium"
//                               >
//                                 No tenants found.
//                               </td>
//                             </tr>
//                           ) : (
//                             recentTenants?.map((user) => (
//                               <tr
//                                 key={user.id}
//                                 className="border-t border-gray-200"
//                               >
//                                 <td className="py-3 px-2">
//                                   <div className="flex gap-2 items-center">
//                                     <img
//                                       src={
//                                         user?.logo
//                                           ? IMAGE_URL + user?.logo
//                                           : userProfile
//                                       }
//                                       alt={user.tenant?.name}
//                                       className="w-8 h-8 rounded-md object-cover"
//                                     />
//                                     <span className="text-body-span text-black !font-semibold">
//                                       {user?.name || "N/A"}
//                                     </span>
//                                   </div>
//                                 </td>
//                                 <td className="py-3 px-2 text-body-span">
//                                   {user?.email || "N/A"}
//                                 </td>
//                                 <td className="py-3 px-2 text-body-span">
//                                   {user?.website_url || "N/A"}
//                                 </td>
//                                 <td className="py-3 px-2 text-body-span">
//                                   {user.createdAt
//                                     ? new Date(
//                                         user.createdAt
//                                       ).toLocaleDateString()
//                                     : "N/A"}
//                                 </td>
//                               </tr>
//                             ))
//                           )}
//                         </tbody>
//                       </table>
//                     </div>
//                   </div>

//                   {/* 🔹 Projected Revenue */}
//                   <div className="bg-white box-shadow p-5 space-y-4 rounded-md">
//                     <div className="flex justify-between items-center">
//                       <h2 className="text-h4 text-blue mb-0">
//                         Projected Revenue
//                       </h2>
//                       <select
//                         className="border border-gray-300 rounded p-1 text-body-span"
//                         value={revenueFilter}
//                         onChange={(e) => setRevenueFilter(e.target.value)}
//                       >
//                         <option value="week">Weekly</option>
//                         <option value="month">Monthly</option>
//                         <option value="year">Yearly</option>
//                       </select>
//                     </div>
//                     <div className="text-h3 text-blue !font-bold">
//                       ${getRevenueValue().toLocaleString()}
//                     </div>
//                   </div>
//                 </div>

//                 {/* 🔹 Right side */}
//                 <div className="space-y-5">
//                   <div className="dashboard-btns hidden md:flex items-center justify-start sm:justify-end flex-wrap gap-3 sm:gap-4 ">
//                     <button
//                       className="text-white login-btn w-fit"
//                       onClick={() => navigate(routes.addTenants)}
//                     >
//                       {PlusIcon} Add Tenant
//                     </button>
//                   </div>

//                   <div className="bg-white box-shadow p-5 space-y-4 rounded-md">
//                     <h2 className="text-h4 text-blue mb-0">
//                       Workforce Snapshot
//                     </h2>
//                     <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-3">
//                       <div className="border border-[#1B3C5233] bg-white rounded-lg p-4 flex flex-col gap-2">
//                         <div className="text-h3 text-blue !font-bold">
//                           {dashboard?.total_tenant_count}
//                         </div>
//                         <div className="text-body-span text-black !font-medium">
//                           Total Tenants
//                         </div>
//                         <div className="mt-2 text-sm mt-auto flex flex-col gap-1">
//                           <div className="text-body-span text-blue !font-medium">
//                             <span className="!font-extrabold">
//                               {dashboard?.active_tenant_count}
//                             </span>{" "}
//                             Active
//                           </div>
//                           <div className="text-body-span text-blue !font-medium">
//                             <span className="!font-extrabold">
//                               {dashboard?.inactive_tenant_count}
//                             </span>{" "}
//                             Inactive
//                           </div>
//                           <div className="text-body-span text-blue !font-medium">
//                             <span className="!font-extrabold">
//                               {dashboard?.pending_tenant_count}
//                             </span>{" "}
//                             Pending
//                           </div>
//                         </div>
//                       </div>

//                       {/* 🔹 Tenant Tier Report */}
//                       <div className="border border-[#1B3C5233] bg-white rounded-lg p-4 space-y-3">
//                         <h2 className="text-sub_span text-blue mb-0">
//                           Tenant Tier Report
//                         </h2>
//                         <div className="flex flex-col gap-3">
//                           <div className="flex items-center justify-between">
//                             <span className="text-body-span text-black !font-medium">
//                               Free Plan
//                             </span>
//                             <span className="text-body-span text-blue !font-bold">
//                               {dashboard?.freePlanList || 0}
//                             </span>
//                           </div>
//                           <div className="flex items-center justify-between">
//                             <span className="text-body-span text-black !font-medium">
//                               Core Plan
//                             </span>
//                             <span className="text-body-span text-blue !font-bold">
//                               {dashboard?.corePlanlist || 0}
//                             </span>
//                           </div>
//                           <div className="flex items-center justify-between">
//                             <span className="text-body-span text-black !font-medium">
//                               Plus Plan
//                             </span>
//                             <span className="text-body-span text-blue !font-bold">
//                               {dashboard?.plusPlanList || 0}
//                             </span>
//                           </div>
//                         </div>
//                       </div>
//                     </div>

//                     <div className="grid grid-cols-1 lg:grid-cols-1 xl:grid-cols-2 gap-4">
//                       {/* 🔹 Tenant Type Report */}
//                       <div className="border border-[#1B3C5233] bg-white rounded-lg p-4 space-y-3">
//                         <h2 className="text-sub_span text-blue mb-0">
//                           Tenant Type Report
//                         </h2>
//                         <div className="flex items-start gap-4">
//                           <div className="w-[70px] h-[70px] flex-none relative">
//                             <PieChart
//                               data={data}
//                               lineWidth={20}
//                               label={() => ""}
//                               labelPosition={70}
//                               rounded
//                               animate
//                             />
//                             <div className="absolute inset-0 flex items-center justify-center">
//                               <div className="text-body text-[#00B051]">
//                                 {total}
//                               </div>
//                             </div>
//                           </div>
//                           <div className="flex flex-col gap-4">
//                             {data?.map((item, index) => (
//                               <div
//                                 key={index}
//                                 className="flex items-center gap-1"
//                               >
//                                 <span
//                                   className="w-[10px] h-[10px] rounded-full inline-block"
//                                   style={{ backgroundColor: item.color }}
//                                 ></span>
//                                 <span className="text-body text-black !font-semibold">
//                                   {item.value}
//                                 </span>
//                                 <span className="text-body text-black !font-medium">
//                                   {item.text}
//                                 </span>
//                               </div>
//                             ))}
//                           </div>
//                         </div>
//                       </div>

//                       {/* 🔹 Tenant Company Strength Report */}
//                       <div className="border border-[#1B3C5233] bg-white rounded-lg p-4 space-y-3">
//                         <h2 className="text-sub_span text-blue mb-0">
//                           Tenant Company Strength Report
//                         </h2>
//                         <div className="flex items-start gap-4 flex-wrap">
//                           <div className="w-[70px] h-[70px] flex-none relative">
//                             <PieChart
//                               data={mapData}
//                               lineWidth={20}
//                               label={() => ""}
//                               labelPosition={70}
//                               rounded
//                               animate
//                             />
//                             <div className="absolute inset-0 flex items-center justify-center">
//                               <div className="text-body text-[#00B051]">
//                                 {mapTotal}
//                               </div>
//                             </div>
//                           </div>
//                           <div className="flex flex-col gap-4 flex-wrap">
//                             {mapData?.map((item, index) => (
//                               <div
//                                 key={index}
//                                 className="flex items-center gap-1"
//                               >
//                                 <span
//                                   className="w-[10px] h-[10px] rounded-full inline-block"
//                                   style={{ backgroundColor: item.color }}
//                                 ></span>
//                                 <span className="text-body text-black !font-semibold">
//                                   {item.value}
//                                 </span>
//                                 <span className="text-body text-black !font-medium">
//                                   {item.text}
//                                 </span>
//                               </div>
//                             ))}
//                           </div>
//                         </div>
//                       </div>

//                       {/* 🔹 Tenant Conversion Rate */}
//                       <div className="border border-[#1B3C5233] bg-white rounded-lg p-4 space-y-3">
//                         <h2 className="text-sub_span text-blue mb-0">
//                           Tenant Conversion Rate
//                         </h2>
//                         <div className="flex flex-col items-start gap-2">
//                           <div className="text-h3 text-blue !font-bold">
//                             {dashboard?.conversion_rate
//                               ? `${parseFloat(
//                                   dashboard.conversion_rate
//                                 ).toFixed(2)}%`
//                               : "0%"}
//                           </div>
//                           <div className="text-body-span text-black !font-medium">
//                             Free ➝ Paid conversion
//                           </div>
//                         </div>
//                       </div>

//                       {/* 🔹 Vacancies (static for now) */}
//                       <div className="border border-[#1B3C5233] bg-white rounded-lg p-4 space-y-3">
//                         <div className="text-sub_span text-blue mb-0">
//                           Vacancies
//                         </div>
//                         <div className="space-y-2">
//                           <div className="items-center gap-2 flex justify-between">
//                             <span className="text-body-span text-blue !font-medium ">
//                               Sales Manager
//                             </span>
//                             <span className="text-sub text-blue !font-medium">
//                               01
//                             </span>
//                           </div>
//                           <div className="items-center gap-2 flex justify-between">
//                             <span className="text-body-span text-blue !font-medium ">
//                               Developer
//                             </span>
//                             <span className="text-sub text-blue !font-medium">
//                               02
//                             </span>
//                           </div>
//                         </div>
//                       </div>

//                       {/* 🔹 Subscription Expiry (static for now) */}
//                       <div className="border border-[#1B3C5233] bg-white rounded-lg p-4 space-y-3">
//                         <div className="text-sub_span text-blue mb-0">
//                           Subscription Expiry
//                         </div>
//                         <div className="space-y-2">
//                           <div className="items-center gap-2 flex justify-between">
//                             <span className="text-body-span text-blue !font-bold ">
//                               Jessica Burke
//                             </span>
//                             <span className="text-sub text-blue !font-medium">
//                               2 Days
//                             </span>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default DashboardPage;

import React, { useEffect, useState } from "react";
import {
  addNewTrentIcon,
  DetailedReportIcon,
  DiscountAnalyticsIcon,
  DownArrowSelect,
  DownRedTrend,
  PaginationLeftArrow,
  PaginationRightArrow,
  RevenueFinancialIcon,
  UpBlueTrend,
  UpGreenTrend,
  UpWhiteTrend,
  UserMaltipleIcon,
  ViewAllIcon,
} from "../assets/icons";
import TabsHeader from "../components/TabsHeader";
import Chart from "react-apexcharts";
import { useNavigate, useOutletContext } from "react-router-dom";
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/20/solid";
import tick from "../assets/images/tick.png";
import { routes } from "../helpers/constants";
import { useDispatch, useSelector } from "react-redux";
import { reqToGetDashboardDetails } from "../redux/slices.js/dashboard/dashboardSlice";
import {
  reqToGetAllFeedback,
  reqToGetFeedBackType,
} from "../redux/slices.js/feedback/feedBackSlice";

const DashboardPage = ({ isOpen }) => {
  const dispatch = useDispatch();
  const dashboardData = useSelector(
    (state) => state.dashboardSlice.dashboard || {}
  );

  const { isSidebarOpen } = useOutletContext();
  const navigate = useNavigate();
  const tabs = [
    { name: "Revenue & Financial overview", icon: RevenueFinancialIcon },
    { name: "Discount analytics", icon: DiscountAnalyticsIcon },
    { name: "Tenant performance", icon: UserMaltipleIcon },
  ];
  const [activeTab, setActiveTab] = useState(tabs[0].name);

  const feedbackState = useSelector((state) => state?.feedbackslice || []);

  const { type = { feedbackType: [], priority: [] }, feedbackList = [] } =
    feedbackState || {};

  useEffect(() => {
    dispatch(
      reqToGetDashboardDetails({
        data: {},
        onSuccess: () => {},
        onFailure: () => {},
      })
    );
    dispatch(
      reqToGetAllFeedback({
        data: {
          page: 1,
          limit: 4,
        },
        onSuccess: (res) => {},
        onFailure: (error) => {
          console.error("Error fetching feedback:", error);
        },
      })
    );
    dispatch(
      reqToGetFeedBackType({
        data: {},
        onSuccess: () => {},
        onFailure: () => {},
      })
    );
  }, [dispatch]);

  // Extract metrics from dashboard data
  const metrics = dashboardData?.data?.metrics || {};
  const monthlyRevenue = dashboardData?.data?.monthlyRevenue || [];
  const grossVsNetRevenue = dashboardData?.data?.grossVsNetRevenue || [];
  const discountAnalytics = dashboardData?.data?.discountAnalytics || [];
  const discountImpact = dashboardData?.data?.discountImpact || [];

  // Format currency values
  const formatCurrency = (value) => {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(value);
  };

  // Revenue trends chart data
  const revenueSeries = [
    {
      name: "Revenue",
      data: monthlyRevenue.map((item) => item.revenue || 0),
    },
  ];

  const revenueOptions = {
    chart: {
      type: "line",
      toolbar: { show: false },
      zoom: {
        enabled: false,
      },
      redrawOnParentResize: true,
      redrawOnWindowResize: true,
    },
    stroke: {
      curve: "smooth",
      width: 2,
      colors: ["#4285F4"],
    },
    grid: {
      borderColor: "#f1f1f1",
    },
    xaxis: {
      categories: monthlyRevenue.map((item) => {
        const date = new Date(item.month);
        return date.toLocaleDateString("en-US", {
          month: "short",
          year: "numeric",
        });
      }),
      labels: {
        style: {
          colors: "#000",
          fontSize: "12px",
          fontFamily: "Rubik",
        },
      },
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
    },
    yaxis: {
      labels: {
        style: {
          colors: "#000",
          fontSize: "12px",
          fontFamily: "Rubik",
        },
        formatter: function (value) {
          return formatCurrency(value);
        },
      },
    },
    tooltip: {
      theme: "light",
      y: {
        formatter: function (value) {
          return formatCurrency(value);
        },
      },
    },
  };

  // Tenant health overview - Calculate from discountImpact data
  const calculateTenantHealth = () => {
    const totalTenants = discountImpact.length;
    if (totalTenants === 0)
      return { excellent: 0, good: 0, fair: 0, atRisk: 0 };

    // Simple calculation based on login activity and subscription status
    const excellent = discountImpact.filter(
      (tenant) =>
        tenant.users.some((user) => user.login_time) &&
        tenant.tenant_subscription.some((sub) => !sub.is_trial)
    ).length;

    const good = discountImpact.filter(
      (tenant) =>
        tenant.users.some((user) => user.login_time) &&
        tenant.tenant_subscription.some((sub) => sub.is_trial)
    ).length;

    const fair = discountImpact.filter(
      (tenant) =>
        !tenant.users.some((user) => user.login_time) &&
        tenant.tenant_subscription.some((sub) => !sub.is_trial)
    ).length;

    const atRisk = discountImpact.filter(
      (tenant) =>
        !tenant.users.some((user) => user.login_time) &&
        tenant.tenant_subscription.some((sub) => sub.is_trial)
    ).length;

    return { excellent, good, fair, atRisk };
  };

  const tenantHealthData = calculateTenantHealth();
  const tenantLabels = ["Excellent", "Good", "Fair", "At risk"];
  const tenantColors = ["#1A1F71", "#1D61B8", "#D0A686", "#D8E77C"];
  const tenantSeries = [
    tenantHealthData.excellent,
    tenantHealthData.good,
    tenantHealthData.fair,
    tenantHealthData.atRisk,
  ];

  const tenantOptions = {
    chart: {
      type: "pie",
      width: "100%",
      redrawOnParentResize: true,
      redrawOnWindowResize: true,
    },
    labels: tenantLabels,
    colors: tenantColors,
    legend: {
      show: false,
      position: "bottom",
      labels: {
        useSeriesColors: false,
      },
    },
    stroke: {
      show: false,
    },
    tooltip: {
      theme: "light",
      enabled: false,
    },
    dataLabels: {
      enabled: false,
    },
  };

  // Gross vs Net Revenue chart
  const grossSeries = [
    {
      name: "Gross Revenue",
      data: grossVsNetRevenue.map((item) => item.gross || 0),
    },
    {
      name: "Net Revenue",
      data: grossVsNetRevenue.map((item) => item.net || 0),
    },
  ];

  const grossOptions = {
    chart: {
      type: "bar",
      height: 400,
      toolbar: {
        show: false,
      },
      redrawOnParentResize: true,
      redrawOnWindowResize: true,
      zoom: {
        enabled: false,
      },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "60%",
        endingShape: "rounded",
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      show: false,
    },
    xaxis: {
      categories: grossVsNetRevenue.map((_, index) => `Month ${index + 1}`),
      labels: {
        style: {
          colors: "#000",
          fontSize: "12px",
          fontFamily: "Rubik",
        },
      },
    },
    yaxis: {
      title: {
        text: undefined,
      },
      labels: {
        style: {
          colors: "#000",
          fontSize: "12px",
          fontFamily: "Rubik",
        },
        formatter: function (value) {
          return formatCurrency(value);
        },
      },
    },
    legend: {
      show: true,
      position: "top",
    },
    fill: {
      opacity: 1,
    },
    colors: ["#E3D6C4", "#4271D5"],
    tooltip: {
      y: {
        formatter: function (val) {
          return formatCurrency(val);
        },
      },
    },
  };

  // Discount breakdown data
  const discountLabels = discountAnalytics.map((item) => item.name);
  const discountColors = [
    "#1A1F71",
    "#1D61B8",
    "#D0A686",
    "#D8E77C",
    "#FF7D00",
    "#F5A623",
  ];
  const discountSeries = discountAnalytics.map((item) => item.percent);
  const discountValues = discountAnalytics.map((item) => item.amount);

  const discountOptions = {
    chart: {
      type: "pie",
      width: "100%",
      redrawOnParentResize: true,
      redrawOnWindowResize: true,
    },
    labels: discountLabels,
    colors: discountColors,
    legend: {
      show: false,
      position: "bottom",
      labels: {
        useSeriesColors: false,
      },
    },
    stroke: {
      show: false,
    },
    tooltip: {
      theme: "light",
      enabled: false,
    },
    dataLabels: {
      enabled: false,
    },
  };

  // Table data from discountImpact
  const tenantsData = discountImpact.map((tenant) => ({
    tenant: tenant.name,
    plan: tenant.tenant_subscription[0]?.plan?.name || "N/A",
    status: tenant.tenant_subscription[0]?.is_trial ? "Trial" : "Active",
    employees: tenant.total_employee || "0",
    mrr: "$0", // You might want to calculate this based on your business logic
    lastActive: tenant.users.some((user) => user.login_time)
      ? new Date(
          tenant.users.find((user) => user.login_time)?.login_time
        ).toLocaleDateString()
      : "Never",
  }));

  // Recent feedback data (you might need to get this from another endpoint)
  const recentFeedback = [
    {
      tenant: "Acme cooperation",
      type: "Bug Report",
      priority: "Medium",
    },
    {
      tenant: "Tech innovators LTD",
      type: "Feature Request",
      priority: "High",
    },
    {
      tenant: "Global services",
      type: "Question",
      priority: "Low",
    },
    {
      tenant: "Retail plus",
      type: "Bug Report",
      priority: "High",
    },
  ];

  // table data pagination
  const [pageSize, setPageSize] = useState(20);
  const [currentPage, setCurrentPage] = useState(1);

  // Pagination logic
  const totalCount = tenantsData.length;
  const totalPages = Math.ceil(totalCount / pageSize);

  // Determine page range based on current page
  const rangeSize = 3;
  const startRange = Math.floor((currentPage - 1) / rangeSize) * rangeSize + 1;
  const endRange = Math.min(startRange + rangeSize - 1, totalPages);

  // Function to navigate to a specific page
  const goToPage = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  // Paginate tenants
  const paginatedTenants = tenantsData.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );

  // Handle page size change
  const handlePageSizeChange = (event) => {
    setPageSize(Number(event.target.value));
    setCurrentPage(1);
  };

  useEffect(() => {
    const t = setTimeout(() => {
      window.dispatchEvent(new Event("resize"));
    }, 120);
    return () => clearTimeout(t);
  }, [dashboardData]);

  // Calculate growth trend icon and color
  const getGrowthTrend = (growth) => {
    if (growth > 0) return { icon: UpGreenTrend, color: "text-green" };
    if (growth < 0) return { icon: DownRedTrend, color: "text-red" };
    return { icon: UpBlueTrend, color: "text-neviblue" };
  };

  const mrrGrowth = getGrowthTrend(metrics.monthly_recurring_revenue?.growth);
  const yearlyGrowth = getGrowthTrend(metrics.yearly_revenue_projection?.value);
  const monthlyDiscountGrowth = getGrowthTrend(
    metrics.monthly_discounts_given?.value
  );
  const yearlyDiscountGrowth = getGrowthTrend(
    metrics.yearly_discounts_given?.value
  );
  const tenantValueGrowth = getGrowthTrend(
    metrics.active_tenant_value?.churn_percent
  );

  return (
    <div className="rounded-md border-[1px] border-solid border-[#F3EFEF] space-y-8 py-6">
      <div className="px-3 sm:px-6">
        <div className="heading flex gap-2 justify-between items-end flex-wrap mb-[24px]">
          <div className="heading-title space-y-1 ">
            <h1 className="text-h2 !font-medium mb-0">
              Command Centre Business Intelligence
            </h1>
            <p className="text-span text-dark mb-0">
              Comprehensive oversight of revenue, tenants, and platform
              performance
            </p>
          </div>
          <div className="heading-btns flex items-center gap-3 flex-wrap">
            <button className="btn-light-gray">
              {DetailedReportIcon} Detailed reports
            </button>
            <button
              className="btn-light-blue"
              onClick={() => {
                navigate(routes.provisionTenants);
              }}
            >
              {UserMaltipleIcon} New Tenant
            </button>
          </div>
        </div>
      </div>

      <div className="px-3 sm:px-6">
        <div
          className={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 xl:gap-6 items-stresh ${
            isSidebarOpen ? "overview-boxs" : ""
          }`}
        >
          {/* Monthly Recurring Revenue */}
          <div className="comman-crad comman-card-blue bg-blue-100 !border-none">
            <div className="title flex flex-col gap-3">
              <p className="text-sub_span text-white mb-0">
                Monthly Recurring Revenue
              </p>
              <h2 className="text-h2 !font-semibold text-white Rubik mb-0">
                {formatCurrency(metrics.monthly_recurring_revenue?.value || 0)}
              </h2>
            </div>
            <div className="flex justify-between items-end mt-2 flex-1">
              <div className="text-sub_span flex items-center gap-1 text-white">
                {UpWhiteTrend} +
                {metrics.monthly_recurring_revenue?.growth?.toFixed(1) || 0}%
                growth
              </div>
              <div className="text-sub_span flex items-center gap-1 text-white">
                {formatCurrency(
                  metrics.monthly_recurring_revenue?.projection || 0
                )}
              </div>
            </div>
          </div>

          {/* Yearly Revenue Projection */}
          <div className="comman-crad bg-yellow">
            <div className="title flex flex-col gap-3">
              <p className="text-sub_span text-dark mb-0">
                Yearly Revenue Projection
              </p>
              <h2 className="text-h2 !font-semibold text-black Rubik mb-0">
                {formatCurrency(metrics.yearly_revenue_projection?.value || 0)}
              </h2>
            </div>
            <div className="flex justify-between items-end mt-2 flex-1">
              <div
                className={`text-sub_span flex items-center gap-1 ${yearlyGrowth.color}`}
              >
                {yearlyGrowth.icon}{" "}
                {metrics.yearly_revenue_projection?.label || "Annual growth"}
              </div>
              <div className="text-sub_span flex items-center gap-1 text-black">
                {metrics.yearly_revenue_projection?.based_on ||
                  "Based on trends"}
              </div>
            </div>
          </div>

          {/* Active Tenants */}
          <div className="comman-crad bg-yellow">
            <div className="title flex flex-col gap-3">
              <p className="text-sub_span text-dark mb-0">Active Tenants</p>
              <h2 className="text-h2 !font-semibold text-green Rubik mb-0">
                {metrics.active_tenants?.activeCount || 0}/
                {metrics.active_tenants?.total || 0}
              </h2>
            </div>
            <div className="w-full h-2 bg-[#F0F0F0] rounded-full mt-auto">
              <div
                className="h-2 bg-[#52C41A] rounded-full"
                style={{
                  width: `${
                    ((metrics.active_tenants?.activeCount || 0) /
                      (metrics.active_tenants?.total || 1)) *
                    100
                  }%`,
                }}
              ></div>
            </div>
          </div>

          {/* Monthly discounts given */}
          <div className="comman-crad bg-yellow">
            <div className="title flex flex-col gap-3">
              <p className="text-sub_span text-dark mb-0">
                Monthly discounts given
              </p>
              <h2 className="text-h2 !font-semibold text-black Rubik mb-0">
                {formatCurrency(metrics.monthly_discounts_given?.value || 0)}
              </h2>
            </div>
            <div className="flex justify-between items-end mt-2 flex-1">
              <div
                className={`text-sub_span flex items-center gap-1 ${monthlyDiscountGrowth.color}`}
              >
                {monthlyDiscountGrowth.icon}{" "}
                {metrics.monthly_discounts_given?.percent_of_revenue?.toFixed(
                  1
                ) || 0}
                % of revenue
              </div>
              <div className="text-sub_span flex items-center gap-1 text-black">
                {metrics.monthly_discounts_given?.time_frame || "This month"}
              </div>
            </div>
          </div>

          {/* Yearly Discounts Given */}
          <div className="comman-crad bg-yellow">
            <div className="title flex flex-col gap-3">
              <p className="text-sub_span text-dark mb-0">
                Yearly Discounts Given
              </p>
              <h2 className="text-h2 !font-semibold text-black Rubik mb-0">
                {formatCurrency(metrics.yearly_discounts_given?.value || 0)}
              </h2>
            </div>
            <div className="flex justify-between items-end mt-2 flex-1">
              <div
                className={`text-sub_span flex items-center gap-1 ${yearlyDiscountGrowth.color}`}
              >
                {yearlyDiscountGrowth.icon} Total YTD
              </div>
              <div className="text-sub_span flex items-center gap-1 text-black">
                {metrics.yearly_discounts_given?.time_frame || "Jan - Nov 2025"}
              </div>
            </div>
          </div>

          {/* Active Tenants Value */}
          <div className="comman-crad bg-yellow">
            <div className="title flex flex-col gap-3">
              <p className="text-sub_span text-dark mb-0">
                Active Tenants Value
              </p>
              <h2 className="text-h2 !font-semibold text-black Rubik mb-0">
                {formatCurrency(metrics.active_tenant_value?.value || 0)}
              </h2>
            </div>
            <div className="flex justify-between items-end mt-2 flex-1">
              <div
                className={`text-sub_span flex items-center gap-1 ${tenantValueGrowth.color}`}
              >
                {tenantValueGrowth.icon}{" "}
                {metrics.active_tenant_value?.churn_percent || 0}% churn
              </div>
              <div className="text-sub_span flex items-center gap-1 text-black">
                {metrics.active_tenant_value?.unit || "per Tenant"}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="px-3 sm:px-6">
        <TabsHeader
          tabs={tabs}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
        />

        {activeTab === "Revenue & Financial overview" ? (
          <div className="flex flex-wrap gap-5">
            <div className="chart-card xl:w-[calc(75%-10px)] md:w-[calc(60%-10px)] w-full">
              <h2 className="text-span text-black !font-semibold mb-0">
                Revenue trends and projection
              </h2>
              <div className="w-full">
                <Chart
                  options={revenueOptions}
                  series={revenueSeries}
                  type="line"
                  height={330}
                  style={{ width: "100%" }}
                />
              </div>
              <p className="text-[#C9C9C9] text-sub_span text-center mb-0">
                Revenue growth trajectory based on current data
              </p>
            </div>

            <div className="chart-card xl:w-[calc(25%-10px)] md:w-[calc(40%-10px)] w-full">
              <h2 className="text-span text-black !font-semibold mb-0">
                Tenant health overview
              </h2>
              <Chart
                options={tenantOptions}
                series={tenantSeries}
                type="pie"
                height={250}
                width="100%"
                className="w-full"
              />

              <div className="text-sm ml-4">
                {tenantLabels.map((label, index) => (
                  <div
                    key={index}
                    className="mb-2 flex items-center justify-between"
                  >
                    <div className="flex items-center gap-2">
                      <div
                        className="w-4 h-4"
                        style={{ backgroundColor: tenantColors[index] }}
                      ></div>
                      <span className="text-span text-black">{label}</span>
                    </div>
                    <span className="text-span text-black">
                      {tenantSeries[index]} tenants
                    </span>
                  </div>
                ))}
              </div>
            </div>
            <div className="chart-card w-full">
              <h2 className="text-span text-black !font-semibold mb-0">
                Revenue impact analysis : Gross vs Net Revenue
              </h2>
              <div className="w-full">
                <Chart
                  options={grossOptions}
                  series={grossSeries}
                  type="bar"
                  height={400}
                  style={{ width: "100%" }}
                />
              </div>
            </div>
          </div>
        ) : activeTab === "Discount analytics" ? (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 xl:gap-6">
            <div className="chart-card w-full">
              <h2 className="text-span text-black !font-semibold mb-0">
                Discount breakdown by type
              </h2>
              <div className="w-full">
                <Chart
                  options={discountOptions}
                  series={discountSeries}
                  type="pie"
                  height={200}
                  width="100%"
                  className="w-full my-5"
                />

                <div className="space-y-6">
                  {discountLabels.map((label, index) => (
                    <div
                      key={index}
                      className="mb-2 flex items-center justify-between"
                    >
                      <div className="flex items-center gap-2">
                        <div
                          className="w-4 h-4"
                          style={{ backgroundColor: discountColors[index] }}
                        ></div>
                        <span className="text-span text-black !font-medium">
                          {label}
                        </span>
                      </div>
                      <span className="text-span text-dark">
                        {discountSeries[index]}% (
                        {formatCurrency(discountValues[index])})
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div className="chart-card w-full">
              <h2 className="text-span text-black !font-semibold mb-0">
                Discount impact detail
              </h2>

              <div className="mt-4 space-y-4">
                <div className="bg-white shadow-[0px_4px_32px_0px_#0000000D] rounded-[10px] px-3 py-5 border-[1px] border-[#F0F0F0]">
                  <p className="text-dark text-sub_span !font-medium mb-0">
                    Total Monthly Discount Impact
                  </p>
                  <h6 className="text-h3 mb-0 text-orange Rubik !font-semibold">
                    {metrics.monthly_discounts_given?.percent_of_revenue?.toFixed(
                      1
                    ) || 0}
                    %
                  </h6>
                </div>

                <div className="">
                  {discountAnalytics.map((item, index) => (
                    <div
                      key={index}
                      className="flex justify-between items-center py-3 border-b last:border-b-0 border-[#F2F2F2]"
                    >
                      <div className="space-y-2">
                        <p className="text-span !font-semibold text-black mb-0">
                          {item.name}
                        </p>
                        <p className="text-span text-dark mb-0">
                          {item.percent}% of total
                        </p>
                      </div>
                      <p className="text-span text-dark mb-0 !font-medium text-orange">
                        {formatCurrency(item.amount)}
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        ) : activeTab === "Tenant performance" ? (
          <div className="space-y-4 xl:space-y-6">
            <div className="chart-card w-full">
              <div className="flex items-center justify-between flex-wrap gap-2 border-b-[1px] border-[D3D6DA3B] pb-[10px]">
                <h3 className="text-span text-black !font-semibold mb-0">
                  Tenant Details
                </h3>
                <button
                  className="btn-light-blue"
                  onClick={() => navigate(routes.addTenants)}
                >
                  {addNewTrentIcon} Add New Tenant
                </button>
              </div>
              <div className="w-full overflow-auto mt-4 rounded-lg max-h-[300px] common-scroll">
                <table className="min-w-[640px] w-full table-auto">
                  <thead className="bg-[#F1F6FF]">
                    <tr>
                      <th>Tenant</th>
                      <th>Plan</th>
                      <th>Status</th>
                      <th>Employees</th>
                      <th>MRR</th>
                      <th>Last active</th>
                    </tr>
                  </thead>
                  <tbody>
                    {paginatedTenants.map((tenant, index) => (
                      <tr key={index}>
                        <td>{tenant.tenant}</td>
                        <td>
                          <span className="px-2 py-1 rounded-full bg-[#FAFAFA] text-[#1e1e1e] text-body">
                            {tenant.plan}
                          </span>
                        </td>
                        <td>
                          <span
                            className={`px-2 py-1 min-w-[57px] inline-block text-center rounded-full text-body ${
                              tenant.status === "Active"
                                ? "bg-[#F6FFEC] text-[#328708]"
                                : "bg-[#FFE9E7] text-[#EA4335]"
                            }`}
                          >
                            {tenant.status}
                          </span>
                        </td>
                        <td>{tenant.employees}</td>
                        <td>{tenant.mrr}</td>
                        <td>{tenant.lastActive}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* Pagination Controls */}
              <div className="flex justify-end gap-2 flex-wrap items-center items-center mt-6">
                <p className="text-sub_span mb-0 !font-medium text-black">
                  Total {totalCount} tenants
                </p>

                <div className="flex items-center space-x-2">
                  {/* Prev Button */}
                  <button
                    className="border-none outline-none disabled:opacity-50"
                    onClick={() => goToPage(currentPage - 1)}
                    disabled={currentPage === 1}
                  >
                    {PaginationLeftArrow}
                  </button>

                  {/* Page Numbers with Dots */}
                  <div className="flex space-x-2">
                    {/* Always show first page */}
                    <button
                      onClick={() => goToPage(1)}
                      className={`flex items-center justify-center rounded-[8px] text-body-span w-[28px] h-[28px] text-center border-[1px] ${
                        currentPage === 1
                          ? "text-blue-100 border-[#4285F4]"
                          : "text-gray-100 border-[#5c5b62]"
                      }`}
                    >
                      1
                    </button>

                    {/* Left dots */}
                    {currentPage > 3 && (
                      <span className="flex items-center justify-center rounded-[8px] text-body-span w-[28px] h-[28px] text-center border-[1px] text-gray-100 border-[#5c5b62]">
                        …
                      </span>
                    )}

                    {/* Middle Pages */}
                    {Array.from({ length: totalPages }, (_, i) => i + 1)
                      .filter(
                        (p) =>
                          p !== 1 &&
                          p !== totalPages &&
                          p >= currentPage - 1 &&
                          p <= currentPage + 1
                      )
                      .map((pageNum) => (
                        <button
                          key={pageNum}
                          onClick={() => goToPage(pageNum)}
                          className={`flex items-center justify-center rounded-[8px] text-body-span w-[28px] h-[28px] text-center border-[1px] ${
                            currentPage === pageNum
                              ? "text-blue-100 border-[#4285F4]"
                              : "text-gray-100 border-[#5c5b62]"
                          }`}
                        >
                          {pageNum}
                        </button>
                      ))}

                    {/* Right dots */}
                    {currentPage < totalPages - 2 && (
                      <span className="flex items-center justify-center rounded-[8px] text-body-span w-[28px] h-[28px] text-center border-[1px] text-gray-100 border-[#5c5b62]">
                        …
                      </span>
                    )}

                    {/* Always show last page */}
                    {totalPages > 1 && (
                      <button
                        onClick={() => goToPage(totalPages)}
                        className={`flex items-center justify-center rounded-[8px] text-body-span w-[28px] h-[28px] text-center border-[1px] ${
                          currentPage === totalPages
                            ? "text-blue-100 border-[#4285F4]"
                            : "text-gray-100 border-[#5c5b62]"
                        }`}
                      >
                        {totalPages}
                      </button>
                    )}
                  </div>

                  {/* Next Button */}
                  <button
                    className="border-none outline-none disabled:opacity-50"
                    onClick={() => goToPage(currentPage + 1)}
                    disabled={currentPage === totalPages}
                  >
                    {PaginationRightArrow}
                  </button>
                </div>

                {/* Page Size Selection */}
                <div className="flex items-center relative">
                  <select
                    id="pageSize"
                    value={pageSize}
                    onChange={handlePageSizeChange}
                    className="w-full text-sub_span text-black border-2 border-[#FAFAFA] rounded-[16px] p-2 pl-3 pr-6 outline-none appearance-none"
                  >
                    {[10, 20, 30, 50, 100].map((size) => (
                      <option key={size} value={size}>
                        {size} / page
                      </option>
                    ))}
                  </select>

                  {/* Custom arrow */}
                  <div className="pointer-events-none absolute inset-y-0 right-2 flex items-center">
                    {DownArrowSelect}
                  </div>
                </div>
              </div>
            </div>

            <div className="flex flex-wrap gap-5">
              <div className="chart-card xl:w-[calc(40%-10px)] md:w-[calc(50%-10px)] w-full">
                <h2 className="text-span text-black !font-semibold mb-0">
                  System Health status
                </h2>
                <div className="text-center">
                  <img src={tick} alt="" className="mx-auto" />
                  <div className="space-y-5">
                    <h3 className="text-h3 text-black !font-semibold Rubik">
                      All system operational
                    </h3>
                    <p className="text-span text-[#52C41A] !font-semibold">
                      99% Uptime
                    </p>
                  </div>
                </div>
                <ul className="space-y-3 mb-0 mt-5">
                  <li className="px-2 pb-3 border-b-[1px] border-[#F2F2F2] flex items-center justify-between">
                    <span className="text-span !font-medium text-[#4F4B45]">
                      API Response Time
                    </span>
                    <span className="text-span !font-semibold text-[#4285F4]">
                      145ms Avg
                    </span>
                  </li>
                  <li className="px-2 pb-3 border-b-[1px] border-[#F2F2F2] flex items-center justify-between">
                    <span className="text-span !font-medium text-[#4F4B45]">
                      Database health
                    </span>
                    <span className="text-span !font-semibold text-[#52C41A]">
                      Excellent
                    </span>
                  </li>
                  <li className="px-2 pb-3 border-b-[1px] border-[#F2F2F2] flex items-center justify-between">
                    <span className="text-span !font-medium text-[#4F4B45]">
                      Active Connections
                    </span>
                    <span className="text-span !font-semibold text-[#4285F4]">
                      2,847
                    </span>
                  </li>
                  <li className="px-2 pb-3 border-b-[1px] border-[#F2F2F2] flex items-center justify-between">
                    <span className="text-span !font-medium text-[#4F4B45]">
                      Storage Usage
                    </span>
                    <span className="text-span !font-semibold text-[#F45C0C]">
                      73% capacity
                    </span>
                  </li>
                </ul>
              </div>
              <div className="chart-card xl:w-[calc(60%-10px)] md:w-[calc(50%-10px)] w-full">
                <h2 className="text-span text-black !font-semibold mb-0">
                  Recent Feedback
                </h2>
                <div className="w-full overflow-auto mt-4 rounded-lg max-h-[300px] common-scroll">
                  <table className="min-w-[500px] w-full table-auto">
                    <thead className="bg-[#F1F6FF]">
                      <tr>
                        <th>Tenant</th>
                        <th>Type</th>
                        <th>Priority</th>
                      </tr>
                    </thead>
                    <tbody>
                      {feedbackList.map((tenant, index) => {
                        // Find type name from feedbackType array
                        const typeObj = type.feedbackType.find(
                          (item) => item.id === tenant.type
                        );
                        const typeName = typeObj ? typeObj.name : "Unknown";

                        // Find priority name from priority array
                        const priorityObj = type.priority.find(
                          (item) => item.id === tenant.priority
                        );
                        const priorityName = priorityObj
                          ? priorityObj.name
                          : "Unknown";

                        return (
                          <tr
                            key={index}
                            className="border-b-[1px] border-[#FAFAFA]"
                          >
                            <td>{tenant?.user?.name}</td>
                            <td>
                              <span
                                className={`px-2 py-1 min-w-[57px] inline-block text-center rounded-full border-[1px] text-body ${
                                  tenant.type === 1 // Bug Report
                                    ? "bg-[#FFF1F0] text-[#F45C0C] border-[#F45C0C]"
                                    : tenant.type === 2 // Feature Request
                                    ? "bg-[#E6F4FF] text-[#4285F4] border-[#4285F4]"
                                    : "bg-[#E2FBFF] text-[#114D56] border-[#114D56]"
                                }`}
                              >
                                {typeName}
                              </span>
                            </td>
                            <td>
                              <span
                                className={`px-2 py-1 min-w-[57px] inline-block text-center rounded-full text-body ${
                                  tenant.priority === 2 // Medium
                                    ? "bg-[#FAFEE1] text-[#808708]"
                                    : tenant.priority === 1 // Low
                                    ? "bg-[#F6FFEC] text-[#328708]"
                                    : "bg-[#FFE9E7] text-[#EA4335]" // High
                                }`}
                              >
                                {priorityName}
                              </span>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
                <button className="btn-light-gray w-full mt-5 !text-[#4285f4]">
                  View all feedback {ViewAllIcon}
                </button>
              </div>
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default DashboardPage;
